export const minimumDeposit = 250;
export const minimumSIInitialAmount = 250;
export const minimumSIAmount = 50;
export const minimumInternalTransfer = 0.01;
